// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';

// Selectors
import { isAttachModeSelector } from '../../reducers/draggingSelector';

// Utils
import { getLocationSection, getIsCollapsed } from '../../../common/elements/utils/elementPropertyUtils';

// Components
import CommentThreadCollapsed from './collapsed/CommentThreadCollapsed';
import CommentThreadExpanded from './CommentThreadExpanded';
import CommentThreadDragPreview from './CommentThreadDragPreview';

// Constants
import { BoardSections } from '../../../common/boards/boardConstants';

export const CommentThreadTypeSwitch = (props) =>
    props.showCollapsed ? (
        <CommentThreadCollapsed {...props} threadId={props.elementId} />
    ) : (
        <CommentThreadExpanded {...props} />
    );

const showCollapsedSelector = () =>
    createSelector(
        (state, ownProps) => ownProps.disableCollapse,
        (state, ownProps) => getIsCollapsed(ownProps.element),
        (state, ownProps) => getLocationSection(ownProps.element),
        (state, ownProps) => ownProps.isDragPreview,
        (state) => isAttachModeSelector(state),
        (disableCollapse, isCollapsed, section, isDragPreview, isAttachMode) =>
            !disableCollapse &&
            ((isCollapsed && ((section !== BoardSections.INBOX && section !== BoardSections.TRASH) || isDragPreview)) ||
                (!isDragPreview && section === BoardSections.ATTACHED) ||
                (isDragPreview && isAttachMode)),
    );

const mapStateToPropsSwitch = () =>
    createStructuredSelector({
        showCollapsed: showCollapsedSelector(),
    });

const CommentThreadSwitch = (props) =>
    props.isDragPreview ? <CommentThreadDragPreview {...props} /> : <CommentThreadTypeSwitch {...props} />;

CommentThreadTypeSwitch.propTypes = CommentThreadSwitch.propTypes = {
    elementId: PropTypes.string.isRequired,
    element: PropTypes.object.isRequired,
    showCollapsed: PropTypes.bool,
    disableCollapse: PropTypes.bool,
    isDragPreview: PropTypes.bool,
};

export default connect(mapStateToPropsSwitch)(CommentThreadSwitch);
